import { RecordedSessionQueries } from './queries';
import { RecordedSessionMutations } from './mutations';

export const RecordedSession = {
  queries: RecordedSessionQueries,
  mutations: RecordedSessionMutations,
};

export * from './types';
